import {getEventOrders} from '../selectors/event'
import {DetailedEvent} from '../types/state'

export const downloadTicketsForEvent = (event: DetailedEvent) => getEventOrders(event).forEach(downloadTickets)

export const downloadTickets = (order: wix.events.ticketing.Order) => window.open(order.ticketsPdf)
